import { BLOCK_TYPE, INLINE_STYLE } from 'draftail'

export const COLORS_INLINE_STYLE = {
  '#003099': { type: '#003099', style: { color: '#003099' }, listClassName: 'PRIMARY_BLUE_003099' },
  '#ff9e00': { type: '#ff9e00', style: { color: '#ff9e00' }, listClassName: 'DARK_YELLOW_FF9E00' },
  '#757575': { type: '#757575', style: { color: '#757575' }, listClassName: 'GRAY_747575' },
  '#000000': { type: '#000000', style: { color: '#000000' }, listClassName: 'PURE_BLACK_000000' },
  '#212121': { type: '#212121', style: { color: '#212121' }, listClassName: 'LIGHT_BLACK_212121' },
}

export const FONT_INLINE_STYLE = {
  FONT_12: { type: 'FONT_12', style: { fontSize: 12 } },
  FONT_14: { type: 'FONT_14', style: { fontSize: 14 } },
  FONT_16: { type: 'FONT_16', style: { fontSize: 16 } },
  FONT_24: { type: 'FONT_24', style: { fontSize: 24 } },
  FONT_48: { type: 'FONT_48', style: { fontSize: 48 } },
}
export const FONT_FAMILY_INLINE_STYLE = {
  jioType: { type: 'jioType', style: { fontFamily: 'jioType' } },
  jioTypeLight: { type: 'jioTypeLight', style: { fontFamily: 'jioType-light' } },
  jioTypeMedium: { type: 'jioTypeMedium', style: { fontFamily: 'jioType-medium' } },
  jioTypeBold: { type: 'jioTypeBold', style: { fontFamily: 'jioType-bold' } },
}

export const INLINE_CONTROL = {
  BOLD: { type: INLINE_STYLE.BOLD, style: { fontWeight: 'bold' } },
  ITALIC: { type: INLINE_STYLE.ITALIC, style: { fontStyle: 'italic' } },
  CODE: { type: INLINE_STYLE.CODE, style: { fontFamily: 'monospaced' } },
  UNDERLINE: {
    type: INLINE_STYLE.UNDERLINE,
    style: { textDecoration: 'underline' },
  },
  STRIKETHROUGH: {
    type: INLINE_STYLE.STRIKETHROUGH,
    style: { textDecoration: 'line-through' },
  },
  MARK: { type: INLINE_STYLE.MARK, style: { backgroundColor: 'yellow' } },
  QUOTATION: {
    type: INLINE_STYLE.QUOTATION,
    style: { backgroundColor: '#ff8f8f', quotes: '"\'" "\'"' },
  },
  SMALL: { type: INLINE_STYLE.SMALL, style: { fontSize: 'bold' } },
  SAMPLE: {
    type: INLINE_STYLE.SAMPLE,
    style: {
      fontFamily:
        "Consolas, Menlo, Monaco, 'Lucida Console', 'Liberation Mono', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Courier New', monospace, sans-serif",
    },
  },
  INSERT: {
    type: INLINE_STYLE.INSERT,
    style: { textDecoration: 'underline', backgroundColor: '#a7ff8a' },
  },
  DELETE: {
    type: INLINE_STYLE.DELETE,
    style: { textDecoration: 'line-through', backgroundColor: '#ff8f8f' },
  },
  KEYBOARD: {
    type: INLINE_STYLE.KEYBOARD,
    style: {
      fontFamily:
        'Consolas, Menlo, Monaco, "Lucida Console", "Liberation Mono", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Courier New", monospace, sans-serif',
      padding: '3px 5px',
      fontSize: '11px',
      lineHeight: '10px',
      color: 'rgb(68, 77, 86)',
      verticalAlign: 'middle',
      backgroundColor: 'rgb(250, 251, 252)',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'rgb(198, 203, 209) rgb(198, 203, 209) rgb(149, 157, 165)',
      borderImage: 'initial',
      borderRadius: '3px',
      boxShadow: 'rgb(149, 157, 165) 0px -1px 0px inset',
    },
  },
  SUPERSCRIPT: { type: INLINE_STYLE.SUPERSCRIPT },
  SUBSCRIPT: { type: INLINE_STYLE.SUBSCRIPT },
  ...COLORS_INLINE_STYLE,
  ...FONT_INLINE_STYLE,
  ...FONT_FAMILY_INLINE_STYLE,
}

export const INLINE_CONTROL_RENDERER = { ...COLORS_INLINE_STYLE, ...FONT_INLINE_STYLE, ...FONT_FAMILY_INLINE_STYLE }

export const BLOCK_CONTROL = {
  UNSTYLED: { type: BLOCK_TYPE.UNSTYLED },
  HEADER_ONE: { type: BLOCK_TYPE.HEADER_ONE },
  HEADER_TWO: { type: BLOCK_TYPE.HEADER_TWO },
  HEADER_THREE: { type: BLOCK_TYPE.HEADER_THREE },
  HEADER_FOUR: { type: BLOCK_TYPE.HEADER_FOUR },
  HEADER_FIVE: { type: BLOCK_TYPE.HEADER_FIVE },
  HEADER_SIX: { type: BLOCK_TYPE.HEADER_SIX },
  UNORDERED_LIST_ITEM: { type: BLOCK_TYPE.UNORDERED_LIST_ITEM },
  ORDERED_LIST_ITEM: { type: BLOCK_TYPE.ORDERED_LIST_ITEM },
  BLOCKQUOTE: {
    type: BLOCK_TYPE.BLOCKQUOTE,
    style: { backgroundColor: 'grey', color: 'white', fontWeight: '600' },
  },
  CODE: { type: BLOCK_TYPE.CODE },
  TINY_TEXT_BLOCK: {
    type: 'tiny-text',
    label: 'Tiny',
    description: 'Legal print',
    element: 'blockquote',
  },
  REDACTED_STYLE: {
    type: 'REDACTED',
    label: 'Redacted',
    description: 'Redacted',
    style: { backgroundColor: 'currentcolor' },
  },
}
